export enum CalculateRouteFeature {
  FERRY = 'ferry',
  TRAIN = 'train',
  TUNNEL = 'tunnel',
  TOLL_ROAD = 'toll-road',
}
